import { createHttpInstance } from '../http'
import { portalUrl } from '../utils'
import { EthercatDevice } from '../entities/EthercatDevice'

export const http = createHttpInstance(portalUrl('/api'), 5000, {
  withCredentials: true,
  withXSRFToken: true,
  xsrfCookieName: import.meta.env.VITE_XSRF_COOKIE_NAME || 'XSRF-TOKEN',
})

export const accounts = {
  me: <T = any>() => http.get<{ data: T }>('/accounts/me'),
}

export type EsiSearchResultType = {
  vendorID: string
  revisionNumber: string
  productCode: string
  esis: {
    name: string
    url: string
  }[]
  xml?: string
}

export const esi = {
  search: async (devices: EthercatDevice[]) => {
    const payload = devices
      .map((device) => {
        return {
          vendorID: device.vendorId,
          productCode: device.type.productCode,
          revisionNumber: device.type.revisionNo,
        }
      })
      .filter((result) => {
        return result.vendorID && result.productCode && result.revisionNumber
      })

    if (!payload.length) {
      return []
    }

    const result = await http.post<{ data: EsiSearchResultType[] }>('/esi/search', {
      devices: payload,
    })

    return result.data.data
  },
  download: (esis: { name: string; url: string }[]) => {
    const esi = esis[0]
    return http.get(esi.url)
  },
}
